import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './css/DateRangePicker.css';

// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// ----------------------------------------------------------------------

const override = {
  position: 'fixed',
  zIndex: 1031,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <Router />
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
